import { RiPencilLine } from '@remixicon/react';
import { useMemo } from 'react';
import { WarehouseLocation } from 'src/api/warehouses.api';
import { AgButton } from 'src/components/ui';
import { GridColObj } from 'src/modules/grids';
import { readLocationTag, readLocationTagValue } from './locationTags';

export default function useWarehouseLocationsColumns(
  tagKeys: string[],
  onEditLocation: (location: WarehouseLocation) => void
): GridColObj<WarehouseLocation> {
  return useMemo(() => {
    const columns: GridColObj<WarehouseLocation> = {
      slug: { headerName: 'Location ID', flex: 1, filterable: false },
      description: { headerName: 'Description', flex: 1, filterable: false },
      capacity: { headerName: 'Pallet Capacity', type: 'number', flex: 1 },
    };

    tagKeys.forEach((tagKey) => {
      columns[`tags.${tagKey}`] = {
        headerName: tagKey,
        flex: 1,
        // `tags.<key>` is no row field; the filter and the export read the tag through this.
        valueGetter: (_value, row) => readLocationTagValue(row.tags, tagKey),
        renderCell: ({ row }) => {
          const tag = readLocationTag(row.tags, tagKey);
          return tag ? <span className="badge">{tag}</span> : null;
        },
      };
    });

    columns.actions = {
      type: 'actions',
      headerName: '',
      width: 50,
      maxWidth: 50,
      renderCell: ({ row }) => (
        <AgButton variant="ghost" size="icon-sm" shape="circle" onPress={() => onEditLocation(row)}>
          <RiPencilLine size={20} />
        </AgButton>
      ),
    };

    return columns;
  }, [tagKeys, onEditLocation]);
}
